import { createFilter } from 'react-select';

export type FilterOptionMethod = (candidate: any, input: string) => boolean;

/**
 * Defines families of strings considered to be equivalent for filter comparisons
 *
 * Note: the default filter behaviour of react-select already ignores accents.
 */
const filterSearchEquivalenceFamilies: string[][] = [
  ['"', '“', '”', '″'], // double quote alternatives
  ['u', 'µ'], // mu
  ['/', '⁄'], // fraction separator
];

const normaliseForFilterComparison = (input: string) => {
  // Replace instances of strings in filterSearchEquivalentFamilies with the first equivalent so they all match
  filterSearchEquivalenceFamilies.forEach((f) => f.slice(1).forEach((s) => (input = input.replace(s, f[0]))));
  return input;
};

/**
 * Returns true if candidate option should be included based on the current input text
 *
 * The default filtering behaviour we want in our core dropdowns
 */
export const defaultFilterOption: FilterOptionMethod = (candidate, input) =>
  defaultFilter(candidate, normaliseForFilterComparison(input));

const defaultFilterConfig: any = {
  stringify: (option: any) => normaliseForFilterComparison(option.label),
};
const defaultFilter = createFilter(defaultFilterConfig);
